module.exports = __webpack_public_path__ + "370214439cc76d0c32c7c3d64ea4d075.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_medium_x1/public/games/coh_image_2.png
// module id = 498
// module chunks = 0